export class BasicMagnet{
    constructor() {
    }
}